import { ShipResponse } from '~/lib/api/smartsend/types';
import OrderInvoice from './OrderInvoice';
import { P2GText } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  shipResponse: ShipResponse;
  wrapper: (children: React.ReactNode) => React.ReactNode;
}

const ProviderGroupSummaryInvoice: React.FC<props> = ({ shipResponse, wrapper }) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  if (!shipResponse?.Links?.some((x) => x.Type.includes('INVOICE'))) {
    return (
      <OrderInvoice
        orderId={Number(shipResponse.Reference)}
        wrapper={wrapper}
        titleComponent={
          <P2GText component="p" colour="primary">
            <strong>
              <Trans t={t} i18nKey="PROVIDER_SUMMARY_INVOICE" defaults="Invoice" />
            </strong>
          </P2GText>
        }
      />
    );
  }

  return null;
};

export default ProviderGroupSummaryInvoice;
